import type { FC } from 'react';
import { HStack, StackProps } from '@chakra-ui/react';

import Chip from 'components/_core/Chip';

import { CardsView } from '../../types';
import { usePaymentCardsListState } from '../PaymentCardsListFiltersProvider';
import locales from './locales';

type Props = StackProps;

export const PaymentCardListViewPicker: FC<Props> = (props) => {
  const { dispatch, view } = usePaymentCardsListState();

  return (
    <HStack spacing="space-16" {...props}>
      <Chip
        isActive={view === CardsView.OWN}
        onClick={() => {
          dispatch({
            payload: CardsView.OWN,
            type: 'UPDATE_CARDS_VIEW',
          });
        }}
      >
        {locales.filters[CardsView.OWN]}
      </Chip>

      <Chip
        isActive={view === CardsView.COMPANY}
        onClick={() => {
          dispatch({
            payload: CardsView.COMPANY,
            type: 'UPDATE_CARDS_VIEW',
          });
        }}
      >
        {locales.filters[CardsView.COMPANY]}
      </Chip>
    </HStack>
  );
};
